import { FaBan } from "react-icons/fa";
import CardNotificacaoBase from "./CardNotificacaoBase";

const CardExameBloqueado = ({ notif }) => {
    const info = notif.atendimento_info || {};

    let dataFormatada = notif.data_criacao || "";
    if (dataFormatada && !dataFormatada.includes('/')) {
        try {
            dataFormatada = new Date(dataFormatada).toLocaleString("pt-BR");
        } catch (e) {}
    }

    const handleClick = () => {
        if (info.uuid) {
            window.location.href = `/atendimentos/edit/${info.uuid}/?tab=exames`;
        } else if (info.id) {
            window.location.href = `/atendimentos/edit/${info.id}/?tab=exames`;
        }
    };

    return (
        <CardNotificacaoBase
            notificacao={notif}
            icon={<FaBan />}
            color="danger"
            text="text-danger"
            label="Exame Bloqueado"
            titulo={
                <span>
                    Tentativa de Exame Bloqueada | Paciente: <strong>{info.beneficiario_nome || 'N/A'}</strong>
                </span>
            }
            descricao={
                <div>
                   <div>Programa: {info.programa_nome || 'N/A'}</div>
                   {notif.dados?.exame_nome && (
                       <div>Exame: {notif.dados.exame_nome}</div>
                   )}
                   {notif.dados?.medico_nome && (
                       <div>Médico: {notif.dados.medico_nome}</div>
                   )}
                </div>
            }
            dataFormatada={dataFormatada}
            onClick={handleClick}
        />
    );
};

export default CardExameBloqueado;
